<!--157 UpdateClassification-->
<div class="dx-field">
  <div class="dx-field-label">{{ 'Klassifizierungssystem' | translate }}</div>
  <div class="dx-field-value">
    <dx-select-box
        [(value)]="selectedClassificationSystemId"
        [dataSource]="classificationSystems"
        displayExpr="name"
        valueExpr="id"
        [searchEnabled]="true">
    </dx-select-box>
  </div>
</div>
